import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const equal = (val: any): ValidatorFn => {
  const key = 'equal';

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === undefined || value === null || value === '') return null;

    if (val !== value) return { [key]: true };

    return null;
  };
};
